import script from "./AddressFields.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddressFields.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__